import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject, map, mergeMap, takeUntil } from 'rxjs';
import { ActionInterface } from 'src/app/shared/models/interfaces/action.interface';
import { DeviceType } from 'src/app/shared/models/interfaces/device-type.type';
import { EducationStepInterface } from 'src/app/shared/models/interfaces/education-step.interface';
import { IomModuleService } from 'src/app/shared/services/iom-module.service';
import { DeviceWidthService } from 'src/app/shared/services/width.service';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';
import { NavigationComponent } from '../../../../shared/components/navigation/navigation.component';
import { NgIf, AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-navigation-page',
    templateUrl: './navigation-page.component.html',
    styleUrls: ['./navigation-page.component.scss'],
    standalone: true,
    imports: [NgIf, NavigationComponent, SpinnerComponent, AsyncPipe]
})
export class NavigationPageComponent implements OnInit, OnDestroy {

  actions$!: Observable<Array<ActionInterface | null>>;
  educationalSteps$: Observable<EducationStepInterface[]>;
  deviceType: DeviceType = 'desktop';
  private destroy$ = new Subject<void>();

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly iom: IomModuleService,
    private deviceWidth: DeviceWidthService
  ) {

    this.educationalSteps$ = this.activatedRoute.params
    .pipe(mergeMap(
      params => {
        const {moduleId} = params;
        if(moduleId) {
          this.iom.checkTotalScore(moduleId);
        }
        this.actions$ = this.iom.getAction$(moduleId, {
          title: 'Продолжить',
          matColor: 'primary'
        }).pipe(map(action => {
          if(action) {
            action.link = ['step', action.link];
          }
          return [action];
        }));
        return this.iom.getModule$(moduleId);}
     ));
  }

  ngOnInit() {
    this.deviceWidth.getDeviceType$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(type => {
      this.deviceType = type;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
